// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b35cfc16","821":"a043cd7a"}[chunkId] + ".chunk.js";
};